import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  input,
  inject,
} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Guid, isNotNil } from '@web/utils';
import { Observable } from 'rxjs';
import {
  BooleanComponent,
  DateTimeComponent,
  DetailsViewComponent,
  ImageThumbnailComponent,
  ImageThumbnailUnsupportedComponent,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { AdminPaymentMethodDataSourceService } from '../../services/admin-payment-method-data-source.service';
import { AdminPaymentMethodDetails } from '../../models/admin-payment-method-details';
import { SummernoteHtmlPreviewComponent } from '@web/shared/external';

@Component({
  selector: 'app-admin-payment-method-details',
  imports: [
    CommonModule,
    DetailsViewComponent,
    DateTimeComponent,
    SpinnerFilledComponent,
    BooleanComponent,
    ImageThumbnailComponent,
    NgOptimizedImage,
    ImageThumbnailUnsupportedComponent,
    SummernoteHtmlPreviewComponent,
  ],
  templateUrl: './admin-payment-method-details.component.html',
  styleUrl: './admin-payment-method-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPaymentMethodDetailsComponent {
  /* prettier-ignore */
  private readonly paymentMethodDataSource = inject(AdminPaymentMethodDataSourceService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  public readonly id = input.required<Guid>();

  protected data$!: Observable<AdminPaymentMethodDetails>;
  protected readonly isNotNil = isNotNil;

  public constructor() {
    effect(() => this.configureDataSource());
  }

  private configureDataSource(): void {
    this.data$ = this.paymentMethodDataSource.fetchDetailsById(this.id());

    this.changeDetectorRef.detectChanges();
  }
}
